// Url contains either /code, /zebra, /knm, /ijsbreker, /code_\w+, /zebra_\w+, /knm_\w+, or /ijsbreker_\w+
export function isOneGateEntry(url: string): boolean {
  const oneGateEntryPattern = /\/(code|zebra|knm|ijsbreker)(_\w+)?((?!.+)|\/)/;
  return oneGateEntryPattern.test(url);
}
